import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
} from "@angular/core";
import {Router, RouterLink} from "@angular/router";
import {Subscription} from "rxjs";
import {User} from "src/app/modules/auth/models/User";
import {AuthService} from "src/app/modules/auth/services/auth.service";
import {ScreenSize} from "src/app/modules/shared/interfaces/ScreenSize.interface";
import {ClickService} from "src/app/modules/shared/services/click.service";
import {ModalService} from "src/app/modules/core/services/modal.service";
import {ScreenSizeService} from "src/app/modules/shared/services/screenSize.service";
import {environment} from "src/environments/environment";
import {NgClass} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {UserAvatarComponent} from "src/app/modules/shared/components/user-avatar/user-avatar.component";

@Component({
  selector: "app-profile-menu",
  templateUrl: "./profile-menu.component.html",
  styleUrls: ["./profile-menu.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterLink, TranslateModule, UserAvatarComponent],
})
export class ProfileMenuComponent implements OnDestroy {
  @Input() user?: User;
  public imagesDomain: string = environment.imagesDomain;
  public isSubmenuOpen = false;
  public isMobile = false;
  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly modalService: ModalService,
    private readonly screenSizeService: ScreenSizeService,
    private readonly clickService: ClickService,
    private readonly cdr: ChangeDetectorRef
  ) {
    const screenSizeSubscription = this.screenSizeService.screenSize$.subscribe(
      (size: ScreenSize) => {
        this.isMobile = size.isMobile;
      }
    );

    const clickSubscription = this.clickService
      .getClickObservable()
      .subscribe((event: Event) => {
        const targetElement = event.target as HTMLElement;
        if (
          !targetElement.closest("div.profile") ||
          targetElement.closest(".profile__submenu li")
        ) {
          this.isSubmenuOpen = false;
          this.cdr.markForCheck();
        }
      });
    this.subscriptions.push(screenSizeSubscription, clickSubscription);
  }

  toggleSubmenu() {
    if (this.isMobile) {
      this.modalService.openModal("profile");
    }
    this.isSubmenuOpen = !this.isSubmenuOpen;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(["/login"]);
  }

  onKeyUp(event: KeyboardEvent, type: string): void {
    if (event.key === "Enter" || event.key === " ") {
      if (type === "logout") {
        this.logout();
      } else if (type === "submenu") {
        this.toggleSubmenu();
      }
    }
  }

  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }
}
